module.exports = __webpack_public_path__ + "static/media/image_16.c4052463.png";